import { Component, Vue } from 'vue-property-decorator'
import textInput from '../../../components/text-input/text-input'
import { ISerpBookCatNames } from '@/types';

@Component({
  components: {
    textInput,
  }
})

export default class ManageCatNames extends Vue {

  private namespace: string = '/Console';

  private catNames: ISerpBookCatNames[] | null = null;

  private alertMessage: string = '';

  private error: boolean = false;

  private get enabled () {

    let enabled = true;

    if (this.catNames != null) {
      
      this.catNames.forEach((cat: ISerpBookCatNames) =>
        cat.categoryName != ''
          && cat.categoryName.length > 0
            ? false
            : enabled = false
      );
    }
    return enabled;
  }

  beforeMount () {

    this.getCatNames();
  }

  private setCatNames (index: number, value: string) {

    if (this.catNames != null) {

      this.catNames[index].categoryName = value;
    }
  }

  private alertReset() {

    setTimeout(() => {   

      if (this.error) {

        this.error = !this.error;
      }

      this.alertMessage = '';
    }, 5000);
  }

  private async save () {

    try {

      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/ManageCategoryNames`, {
        model: this.catNames
      });

      this.alertMessage = 'Successfully Saved.';
      this.alertReset();
    } catch (err) {

      this.error = !this.error;
      this.alertMessage = 'Ooops... Something went wrong.'
      this.alertReset();
    }
  }
 
  private async getCatNames () {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/SerpBookCategoryNames`);

      this.catNames = response.data;
    } catch (err) {

      console.error(err);
    }
  }
}